var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.375,
    height: 32,
    viewBox: "0 0 39.375 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.345,66.969C311.854,78.332,303.382,91,288.383,91A22.865,22.865,0,0,1,276,87.37a16.242,16.242,0,0,0,11.959-3.346,8.085,8.085,0,0,1-7.546-5.61,8.1,8.1,0,0,0,3.647-.137,8.088,8.088,0,0,1-6.479-8.023,8.037,8.037,0,0,0,3.66,1.009,8.086,8.086,0,0,1-2.5-10.785,22.931,22.931,0,0,0,16.65,8.441,8.084,8.084,0,0,1,13.766-7.369,16.156,16.156,0,0,0,5.13-1.96,8.093,8.093,0,0,1-3.552,4.469,16.134,16.134,0,0,0,4.64-1.271,16.4,16.4,0,0,1-4.031,4.182",
    transform: "translate(-276 -59)",
    fill: "#f6c254",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0a6731e8a3a27a34827b3a82b5bb79ba.svg";
export { ForwardRef as ReactComponent };